"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const Option_vue_1 = __importDefault(require("./Option.vue"));
let OptionGroup = class OptionGroup extends vue_property_decorator_1.Vue {
};
__decorate([
    vue_property_decorator_1.Prop({ default: () => {
            return {
                label: "",
                options: []
            };
        } })
], OptionGroup.prototype, "groupData", void 0);
OptionGroup = __decorate([
    vue_property_decorator_1.Component({
        components: {
            Option: Option_vue_1.default
        }
    })
], OptionGroup);
exports.default = OptionGroup;
